(ns ^:dev/once builder.core
  (:require [reagent.core :as r]
            [reagent.dom]
            [reagent.ratom :as ratom]
            ["react-dom/client" :refer [createRoot]]
            [re-frame.core :as rf]
            [zframes.routing]
            [builder.pages :as pages]
            [builder.routes]

            [builder.index.view]
            [builder.builder.view]))

(defn current-page []
  (let [route @(rf/subscribe [:route-map/current-route])
        not-found? @(rf/subscribe [:route-map/error])]
    [:div
     #_[:style "body {background-color: #F3F4F6;}  a:hover {text-decoration: none;}"]
     (if not-found?
       [:div.not-found (str "Route not found")]
       (if-let [page (get @pages/pages (:match route))]
         [page (:params route)]
         (do (when (:match route)
               (js/console.warn (str "Page not defined [" (:match route) "]")))
             [:div.not-found ""])))
     ])
  )

(defonce root (createRoot (.getElementById js/document "app")))

(defn mount-root []
  (println "mount -root ")
  (.render root (r/as-element [(fn [] current-page)])))

(rf/reg-event-fx
 ::initialize
 (fn [{db :db} _]
   {:db {:route-map/routes builder.routes/routes}
    :route-map/start {}}
   )
 )

(defn re-render []
  (mount-root))

(defn init []
  (mount-root)
  (rf/dispatch [::initialize]))
